import {Module} from 'vuex';
import {RootState} from '@/types';
import {namespace} from 'vuex-class';
import SkillApi from '@/api/SkillApi';
import {
  SET_SKILL,
  SET_SKILLS,
  SET_CATEGORIES,
  SET_SOFTSKILL,
  SET_HARD_SKILL,
} from '@/store/mutationTypes';

export const skillModule = namespace('skill');
export interface Skill {
  [key: string]: any;
}

interface SkillState {
  skills: Skill[];
  skill: Skill | null;
  categories: Skill[];
  soft_skill: Skill[];
  hard_skill: Skill[];
}
export default <Module<SkillState, RootState>>{
  namespaced: true,
  state: {
    skills: [],
    skill: null,
    categories: [],
    soft_skill: [],
    hard_skill: [],
  },
  mutations: {
    [SET_SKILLS](state, data) {
      state.skills = data;
    },
    [SET_SKILL](state, data) {
      state.skill = data;
    },
    [SET_SKILLS](state, data) {
      state.skills = data;
    },
    [SET_CATEGORIES](state, data) {
      state.categories = data;
    },
    [SET_SOFTSKILL](state, data) {
      state.categories = data;
    },
    [SET_HARD_SKILL](state, data) {
      state.hard_skill = data;
    },
  },
  actions: {
    async getSkill({commit}, params = {}) {
      try {
        const {data} = await SkillApi.getSkill(params);
        commit(SET_SKILLS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getSkills({commit}, params = {}) {
      try {
        const {data} = await SkillApi.getSkills(params);
        commit(SET_SKILLS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getDetailSkill({commit}) {
      try {
        const {data} = await SkillApi.getDetail();
        commit(SET_SKILLS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async updateSkill(_, payload) {
      try {
        const data = await SkillApi.updateSkill(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async createSkill(_, payload) {
      try {
        const data = await SkillApi.createSkill(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async delete(_, id) {
      try {
        const {data} = await SkillApi.delete(id);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getCategory({commit}, params = {}) {
      try {
        const {data} = await SkillApi.getCategory(params);
        commit(SET_CATEGORIES, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getSoftSkill({commit}, params = {}) {
      try {
        const {data} = await SkillApi.getSoftSkill(params);
        commit(SET_SOFTSKILL, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getHardSkill({commit}, params = {}) {
      try {
        const {data} = await SkillApi.getHardSkill(params);
        commit(SET_SOFTSKILL, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
};
